type TranslationFn = (key: string) => string;

export const getFrequencyOptions = (t: TranslationFn) => [
  { key: "month", value: "month", text: t("common.monthly") },
  { key: "quarter", value: "quarter", text: t("common.quarterly") },
  { key: "semi-annual", value: "semi-annual", text: t("common.semiAnnually") },
  { key: "year", value: "year", text: t("common.annually") }
];

export const getAccrualOptions = (t: TranslationFn) => [
  { key: "actual_actual", value: "actual_actual", text: t("accrual.actualActual") },
  { key: "actual_360", value: "actual_360", text: t("accrual.actual360") },
  { key: "actual_365", value: "actual_365", text: t("accrual.actual365") },
  { key: "30_360", value: "30_360", text: t("accrual.thirty360") }
];

export const DAY_COUNT_CONVENTION_OPTIONS = [
  { key: "actual_actual", value: "actual_actual", text: "Actual/Actual" },
  { key: "actual_360", value: "actual_360", text: "Actual/360" },
  { key: "actual_365", value: "actual_365", text: "Actual/365" },
  { key: "30_360", value: "30_360", text: "30/360" }
];

// Step IDs — 1-based, with 0 reserved for the edit-mode choice step
// 0:  Edit Choice (edit mode only)
// 1:  Debt Configuration
// 2:  Principal Repayment Setup
// 3:  Interest Type
// 4:  Interest Rate Terms
// 5:  PIK Interest Terms
// 6:  Arrangement Fees
// 7:  Review & Confirm
// 8:  First Drawdown
// 9:  Review & Confirm Drawdown
// 10: All Done!
export const STEP_META: Record<number, { titleKey: string; subtitleKey: string }> = {
  0: { titleKey: "wizard.meta.editChoice.title", subtitleKey: "wizard.meta.editChoice.subtitle" },
  1: { titleKey: "wizard.meta.debtConfig.title", subtitleKey: "wizard.meta.debtConfig.subtitle" },
  2: { titleKey: "wizard.meta.principalSetup.title", subtitleKey: "wizard.meta.principalSetup.subtitle" },
  3: { titleKey: "wizard.meta.interestType.title", subtitleKey: "wizard.meta.interestType.subtitle" },
  4: { titleKey: "wizard.meta.interestTerms.title", subtitleKey: "wizard.meta.interestTerms.subtitle" },
  5: { titleKey: "wizard.meta.pikTerms.title", subtitleKey: "wizard.meta.pikTerms.subtitle" },
  6: { titleKey: "wizard.meta.fees.title", subtitleKey: "wizard.meta.fees.subtitle" },
  7: { titleKey: "wizard.meta.review.title", subtitleKey: "wizard.meta.review.subtitle" },
  8: { titleKey: "wizard.meta.drawdown.title", subtitleKey: "wizard.meta.drawdown.subtitle" },
  9: { titleKey: "wizard.meta.drawdownReview.title", subtitleKey: "wizard.meta.drawdownReview.subtitle" },
  10: { titleKey: "wizard.meta.done.title", subtitleKey: "wizard.meta.done.subtitle" }
};
